const config = {
  "api_url":(function(){
    //console.log("B",process.env.API_TYPE)
    if(process.env.API_TYPE === "development"){
      return "https://psidev2.photospot.jp/srv/api"
    }else if(process.env.API_TYPE === "production") {
      return "https://psidev2.photospot.jp/srv/api"
    }
    return "http://192.168.2.30/api"
  })()
}

//console.log("process.env.API_TYPE","*"+process.env.API_TYPE+"*",config)
export default config;



// WEBPACK FOOTER //
// ./src/config.js